/**************************************************
 * Nombre:       Seccion_Todos_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Lista_Productos from "./Componentes/Lista_Productos";
import Home_Categorias from "./Componentes/Home_Categorias";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {irArriba} from "../../Utilidades/irArriba";
import Tabs_Sub_Categorias from "./Componentes/Tabs_Sub_Categorias";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";

const Seccion_Todos_Productos = () => {
    const {sCell} = useResponsive()
    const [escogido, setEscogido] = useState('Todo')
    const [productos, setProductos] = useState([])

    useEffect(() => {

        if (escogido) {

            setProductos([])
            let w = [where('tipo', '==', escogido), where('estado', '==', 'Publicado')]
            if (escogido === 'Todo') {
                w = [where('estado', '==', 'Publicado')]
            }

            obtenerColWheres({col: 'productos', wheres: w}).then((dox) => {
                setProductos(dox.data)
            })

        }

    }, [escogido])

    useEffect(() => {
        irArriba()
    }, [])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Tabs_Sub_Categorias escogido={escogido} setEscogido={setEscogido}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 0}}>
                <Lista_Productos productos={productos}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: sCell ? 8 : 16, mb: sCell ? 8 : 16}}>
                <Home_Categorias/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Todos_Productos